import { useTheme } from "@fluentui/react/lib/Theme";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";
import { useMemo } from "react";

export function useSearchStyles() {
  const { semanticColors, effects, fonts } = useTheme();

  return useMemo(
    () => mergeStyleSets({
      chipWrap: {
        display: `flex`,
        flexWrap: `wrap`,
        gap: `8px`
      },

      groupChip: {
        padding: `4px 8px`,
        margin: `5px 0 5px 5px`
      },

      orGroup: {
        border: `1px solid ${semanticColors.variantBorder}`,
        borderRadius: `6px`,
        borderColor: semanticColors.primaryButtonBackground,
        backgroundColor: semanticColors.bodyBackground,
        boxShadow: effects.elevation4
      },

      andGroup: {},

      operatorBadge: {
        backgroundColor: semanticColors.successBackground,
        color: semanticColors.bodyBackground,
        padding: `6px`,
        borderRadius: `4px`,
        fontSize: fonts.xSmall.fontSize,
        fontWeight: 600,
        alignSelf: `center`,
        marginRight: `4px`
      }
    }),
    [
      effects.elevation4,
      fonts.xSmall.fontSize,
      semanticColors.bodyBackground,
      semanticColors.primaryButtonBackground,
      semanticColors.successBackground,
      semanticColors.variantBorder
    ]
  );
}
